import request from '@/utils/request'


// 查询车辆运费列表
export function listShippingTemplateVehicle(query) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/list',
    method: 'post',
    data: query
  })
}

// 查询车辆运费分页
export function pageShippingTemplateVehicle(query) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询车辆运费详细
export function getShippingTemplateVehicle(data) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/detail',
    method: 'get',
    params: data
  })
}

// 新增车辆运费
export function addShippingTemplateVehicle(data) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/add',
    method: 'post',
    data: data
  })
}

// 修改车辆运费
export function updateShippingTemplateVehicle(data) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/edit',
    method: 'post',
    data: data
  })
}

// 删除车辆运费
export function delShippingTemplateVehicle(data) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/delete',
    method: 'post',
    data: data
  })
}

export function importVehicle(data) {
  return request({
    url: '/biz/admin/shipping/template/vehicle/import',
    method: 'post',
    data: data
  })
}


